import React from 'react';
import { Container, Grid, Segment, Header } from 'semantic-ui-react';

export const PageNotFound = () => {
  return (
    <div>
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 500 }}>
            <Segment>
              <Header as="h1" textAlign="center">
                We can't find that page!
              </Header>
              <Header as="h4" textAlign="center">
                Happily and sadly, you have not been charged.
              </Header>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
